import { render, staticRenderFns } from "./UnknownSdcvanDeliveryDRecords.vue?vue&type=template&id=18ab2a72&"
import script from "./UnknownSdcvanDeliveryDRecords.vue?vue&type=script&lang=ts&"
export * from "./UnknownSdcvanDeliveryDRecords.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports